import styled from '@emotion/styled';
import { Component } from 'react';

import { FAQData } from './data.js';
import WarrantyFooter from '../footer';
import Page from '../page';
import { ASSET_URLS } from '../utils';

const { PlusIcon, MinusIcon } = ASSET_URLS;

const AccordianContainer = styled.div`
  & + .footnote {
    margin-top: 25px;
  }
  @media (min-width: 1032px) {
    height: 864px;
  }
`;

const Accordian = styled.div`
  & {
    display: block;
    position: relative;
    border: 1px solid #f8f8f8;

    label {
      padding: 12px 15px;
      color: black;
      font-size: 16px;
      background: #fff;
      border-bottom: 1px solid #bcbcbc;
      position: relative;
      width: 100%;
      display: flex;
      margin: 0;
      cursor: pointer;
      font-weight: 500;
      justify-content: space-between;

      &:after {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        font-weight: 700;
      }
    }

    .expand-collapse {
      transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
      max-height: 0;
      background: white;
      overflow: hidden;
    }

    .content {
      padding: 10px 15px;
      font-size: 14px;
      border-bottom: 1px solid #bcbcbc;
    }

    input[type='checkbox'] {
      display: none;
      &:checked ~ .expand-collapse {
        max-height: 800px;
        transition: max-height 1s ease-in-out;
      }
    }

    .arrow-container {
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;
      align-items: center;
    }

    input[type='checkbox']:checked + label .arrow-container {
      .minus-icon {
        display: block;
      }
      .plus-icon {
        display: none;
      }
    }

    input[type='checkbox']:not(:checked) + label .arrow-container {
      .minus-icon {
        display: none;
      }
      .plus-icon {
        display: block;
      }
    }
  }
`;

const Question = styled.div`
  font-family: 'akzidenz-grotesk', sans-serif;
  font-size: 16px;
  color: #000000;
`;

const Answer = styled.div`
  font-family: 'akzidenz-grotesk', sans-serif;
  font-size: 14px;
  color: #000000;
`;

export default class FAQPage extends Component {
  closeOthers(event) {
    const { target } = event;
    const targetId = target.id;
    const otherQuestions = document.querySelectorAll(`input[type="checkbox"]:not(#${targetId})`);
    if (target.checked === true) {
      for (const question of otherQuestions) {
        question.checked = false;
      }
    }
  }

  render() {
    return (
      <Page>
        <AccordianContainer>
          <Accordian selectedIcon={MinusIcon}>
            {FAQData.map((elem, index) => (
              <div key={index}>
                <input type="checkbox" id={`item${index}`} onClick={this.closeOthers} />
                <label htmlFor={`item${index}`} data-track="reveal" data-track-accordion={`item${index}_track`}>
                  <Question
                    dangerouslySetInnerHTML={{
                      __html: elem.title,
                    }}
                  />
                  <div className="arrow-container">
                    <img src={PlusIcon} className="plus-icon" />
                    <img src={MinusIcon} className="minus-icon" />
                  </div>
                </label>
                <div className="expand-collapse">
                  <div className="content">
                    <div className="document-download-list">
                      <Answer
                        dangerouslySetInnerHTML={{
                          __html: elem.content,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Accordian>
        </AccordianContainer>
        <WarrantyFooter />
      </Page>
    );
  }
}
